// @flow

import nubankImageSrc from './nubank.svg';
import santanderImageSrc from './santander.svg';
import bancoDoBrasilImageSrc from './banco-do-brasil.svg';
import caixaSrc from './caixa.svg';
import bradescoImageSrc from './bradesco.svg';
import originalImageSrc from './original.svg';
import interImageSrc from './inter.svg';
import c6ImageSrc from './c6.svg';
import bancoobImageSrc from './bancoob.svg';
import panImageSrc from './pan.svg';
import sicrediImageSrc from './sicredi.svg';
import agibankImageSrc from './agibank.svg';
import bmgImageSrc from './bmg.svg';
import brbImageSrc from './brb.svg';
import itauImageSrc from './itau.svg';

export function getBrandSource(brandName: string): string {
  switch (brandName) {
    case 'nubank':
      return nubankImageSrc;
    case 'santander':
      return santanderImageSrc;
    case 'bancodobrasil':
      return bancoDoBrasilImageSrc;
    case 'caixa':
      return caixaSrc;
    case 'bradesco':
      return bradescoImageSrc;
    case 'original':
      return originalImageSrc;
    case 'inter':
      return interImageSrc;
    case 'c6':
      return c6ImageSrc;
    case 'bancoob':
      return bancoobImageSrc;
    case 'bancopan':
      return panImageSrc;
    case 'sicredi':
      return sicrediImageSrc;
    case 'agibank':
      return agibankImageSrc;
    case 'bancobmg':
      return bmgImageSrc;
    case 'brb':
      return brbImageSrc;
    case 'itau':
      return itauImageSrc;
    default:
      throw new Error(`getBrandSource - Brand  "${brandName} not supported"`);
  }
}
